module.exports = __webpack_public_path__ + "static/livestreaming-1-6485bdfc1fba5f79ff44180f5f153b4d.png";